let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7AyTn")).then(() => parcelRequire('c6im9'));